import { render, staticRenderFns } from "./SuperuserUploadPanel.vue?vue&type=template&id=71c01fcc&scoped=true"
import script from "./SuperuserUploadPanel.vue?vue&type=script&lang=js"
export * from "./SuperuserUploadPanel.vue?vue&type=script&lang=js"
import style0 from "./SuperuserUploadPanel.vue?vue&type=style&index=0&id=71c01fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c01fcc",
  null
  
)

export default component.exports